import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  Tab,
  Tabs,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import HttpService from '../../hooks/Https-services';
import { API_ROUTES, PRIORITY } from '../../utils/constant';
import moment from 'moment';
import ReactApexChart from 'react-apexcharts';
import { DateRangePicker } from 'rsuite';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ReportChart from '../ReportDashboard/ReportGraph';
import ReportTable from './ReportTable';
import { StatusDialog } from '../../components/custom-dialog';
import { LoadingButton } from '@mui/lab';
import { useBoolean } from '../../hooks/use-boolean';
import usePopover from '../../hooks/use-popover';
function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      sx={{ p: 3 }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

const Games = () => {
  const {
    allowedMaxDays,
    allowedDays,
    allowedRange,
    beforeToday,
    afterToday,
    combine,
  } = DateRangePicker;
  const ranges = [
    {
      label: 'Today',
      value: [new Date(), new Date()] as [Date, Date], // Explicitly typed as a tuple
    },
    {
      label: 'Yesterday',
      value: [
        new Date(new Date().setDate(new Date().getDate() - 1)),
        new Date(new Date().setDate(new Date().getDate() - 1)),
      ] as [Date, Date], // Explicitly typed as a tuple
    },
    {
      label: 'Last 30 Days',
      value: [
        new Date(new Date().setDate(new Date().getDate() - 30)),
        new Date(),
      ] as [Date, Date], // Explicitly typed as a tuple
    },
  ];
  const rangesForDownload = [
    {
      label: 'Last 60 Days',
      value: [
        new Date(new Date().setDate(new Date().getDate() - 60)),
        new Date(),
      ] as [Date, Date], // Explicitly typed as a tuple
    },
    {
      label: 'Last 90 Days',
      value: [
        new Date(new Date().setDate(new Date().getDate() - 90)),
        new Date(),
      ] as [Date, Date], // Explicitly typed as a tuple
    },
    {
      label: 'Last 180 Days',
      value: [
        new Date(new Date().setDate(new Date().getDate() - 180)),
        new Date(),
      ] as [Date, Date], // Explicitly typed as a tuple
    },
  ];
  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dateRangeReport, setDateRangeReport] = useState<[Date, Date]>([
    new Date(new Date().setDate(new Date().getDate() - 30)),
    new Date(),
  ]);
  const [downloadDateRangeReport, setDownloadDateRangeReport] = useState<
    [Date, Date]
  >([new Date(new Date().setDate(new Date().getDate() - 30)), new Date()]);

  const [csvDataForTable, setCsvDataTable] = React.useState<any>([]);
  const [isLoadingCsv, setIsLoadingCsv] = useState(false);
  const [teams, setTeams] = React.useState<any>([]);
  const [selectedTeams, setSelectedTeams] = React.useState<any>([]);
  const [selectedTeamsKeys, setSelectedTeamsKeys] = React.useState<any[]>([]);
  const [isTeamLoaded, setIsTeamLoaded] = React.useState(false);
  const [isCsvDataLoaded, setIsCsvDataLoaded] = React.useState(false);
  const [selectPriority, setSelectPriority] = React.useState<any[]>([]);
  const [selectedPriorityKeys, setSelectedPriorityKeys] = useState<number[]>(
    []
  );
  const csvReport = useBoolean();
  const popover = usePopover();

  const fetchTeamsList = React.useCallback(async () => {
    try {
      const response = await HttpService.get(API_ROUTES.fatchAllTeam);
      const teamsData = response.data.data;
      setTeams(teamsData);

      // Select all teams except the one with id 1
      const defaultSelectedTeams = teamsData.filter(
        (team: any) => team.id !== 1
      );
      setIsTeamLoaded(true);
      setSelectedTeams(defaultSelectedTeams);
      setSelectedTeamsKeys(defaultSelectedTeams.map((team: any) => team.id));
    } catch (error: any) {
      setIsTeamLoaded(true);
      console.error('Error fetching teams list:', error);
    }
  }, []);

  // Call fetchTeamsList only once on component mount
  React.useEffect(() => {
    fetchTeamsList();
  }, [fetchTeamsList]);
  const handleChangeTeams = (event: any, newValue: any) => {
    setSelectedTeams(newValue);
    const selectedKeys = newValue.map((option: any) => option.id);
    setSelectedTeamsKeys(selectedKeys);
  };
  const handleDateChangeReport = (value: any) => {
    setDateRangeReport(value);
  };

  const handleDownloadDateChangeReport = (value: any) => {
    setDownloadDateRangeReport(value);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const clearFilter = () => {
    setSelectedTeamsKeys([]);
    setSelectedTeams([]);
    setSelectPriority([]);
    setSelectedPriorityKeys([]);
    setIsTeamLoaded(true);
  };

  const downloadCSV = async () => {
    setIsLoadingCsv(true);

    const formatDate = (date: string) =>
      date ? moment(date).format('D/M/YYYY HH:mm') : 'N/A';

    const createCSVContent = (headers: string[], rows: any[]) =>
      [headers, ...rows].map((row) => row.join(',')).join('\n');

    const downloadCSVFile = (csvContent: string, fileName: string) => {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };

    if (tabIndex === 0) {
      try {
        const query: any = {};
        if (downloadDateRangeReport) {
          query.startDate = moment(downloadDateRangeReport[0]).format(
            'DD-MM-YYYY'
          );
          query.endDate = moment(downloadDateRangeReport[1]).format(
            'DD-MM-YYYY'
          );
        }
        if (selectedTeamsKeys.length > 0) {
          query.teamIds = selectedTeamsKeys.join(',');
        }
        if (selectedPriorityKeys.length > 0) {
          query.priority = selectedPriorityKeys.join(',');
        }

        const response = await HttpService.get(
          `${API_ROUTES.reportData}?${new URLSearchParams(query).toString()}`
        );
        const csvData = response.data.data;
        const dates = csvData.map((entry: any) => entry.date);
        const maxGameIds = Math.max(
          ...csvData.map((entry: any) => entry.gameIds.length)
        );
        const headers = ['Sr No', ...dates];

        const rows = Array.from({ length: maxGameIds }, (_, i) => [
          i + 1,
          ...csvData.map((entry: any) => entry.gameIds[i] || ''),
        ]);

        downloadCSVFile(createCSVContent(headers, rows), 'game_data.csv');
        setIsLoadingCsv(false);
      } catch (error) {
        console.error('Error fetching chart data:', error);
      } finally {
        setLoading(false);
        setDownloadDateRangeReport([
          new Date(new Date().setDate(new Date().getDate() - 30)),
          new Date(),
        ]);
      }
    } else {
      try {
        const query: any = { page: 0 };
        if (downloadDateRangeReport) {
          query.startDate = moment(downloadDateRangeReport[0]).format(
            'DD-MM-YYYY'
          );
          query.endDate = moment(downloadDateRangeReport[1]).format(
            'DD-MM-YYYY'
          );
        }
        if (selectedTeamsKeys.length > 0) {
          query.teamIds = selectedTeamsKeys.join(',');
        }

        const response = await HttpService.get(
          API_ROUTES.completedGameList +
            `?${new URLSearchParams(query).toString()}`
        );

        const apiData = response.data.data.list;
        setCsvDataTable(apiData);

        if (apiData.length > 0) {
          const headers = [
            'GameId',
            'Priority',
            'Game Date',
            'Teams',
            'Fetched',
            'Completed',
          ];

          const rows = apiData.map((row: any) => [
            row.gameId,
            row.priority,
            formatDate(row.game.dateTime),
            `${row.game.homeTeam.nameEn} vs ${row.game.awayTeam.nameEn}`,
            formatDate(row.createdAt),
            formatDate(row.gameCompletedAt),
          ]);

          downloadCSVFile(createCSVContent(headers, rows), 'games_data.csv');
        }
      } catch (error) {
        console.error('Error fetching chart data:', error);
      } finally {
        setIsLoadingCsv(false);
        setDownloadDateRangeReport([
          new Date(new Date().setDate(new Date().getDate() - 30)),
          new Date(),
        ]);
      }
    }
  };

  const priorityOptions = Object.entries(PRIORITY).map(([key, value]) => ({
    key: Number(key), // Convert key to a number
    label: value,
  }));
  const handleChangePriority = (event: any, newValue: any) => {
    setSelectPriority(newValue);
    const selectedKeys = newValue.map((option: { key: number }) => option.key);
    setSelectedPriorityKeys(selectedKeys);
  };
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          margin: '10px 0',
          // alignItems: 'flex-end',
          justifyContent: 'flex-end',
        }}
      >
        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl sx={{ minWidth: 200 }}>
            <Autocomplete
              size="small"
              multiple
              fullWidth
              id="tags-outlined"
              options={priorityOptions}
              value={selectPriority}
              getOptionLabel={(option) => option.label}
              onChange={(event, newValue) => {
                handleChangePriority(event, newValue);
              }}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Priority" />
              )}
              isOptionEqualToValue={(option, value) => option.key === value.key}
            />
          </FormControl>
          <Autocomplete
            size="small"
            multiple
            sx={{ minWidth: 200 }}
            id="role-selector"
            options={teams}
            value={selectedTeams} // Replace with your selected roles state
            getOptionLabel={(option: any) => option.userTeamKey}
            onChange={(event, newValue) => {
              handleChangeTeams(event, newValue); // Replace with your role change handler
            }}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Teams" />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />

          <Box>
            <Button
              onClick={() => clearFilter()}
              variant="contained"
              sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
            >
              Clear Filter
            </Button>
          </Box>
        </Box>
        <DateRangePicker
          character=" – "
          size="lg"
          shouldDisableDate={combine(allowedMaxDays(31), afterToday())}
          onChange={handleDateChangeReport}
          value={dateRangeReport}
          ranges={ranges}
        />{' '}
        <Button
          variant="contained"
          sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
          color="primary"
          size="small"
          startIcon={<FileDownloadIcon fontSize="small" />}
          onClick={() => {
            csvReport.onTrue();
            popover.onClose();
          }}
        >
          Download Report
        </Button>
      </Box>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        aria-label="Dashboard Tabs"
      >
        <Tab label="Report" />
        <Tab label="Games" />
      </Tabs>

      <TabPanel
        value={tabIndex}
        index={0}
        sx={
          {
            // padding: '0px !important',
            // margin: '0px !important',
          }
        }
      >
        <ReportChart
          dateRangeReport={dateRangeReport}
          selectedTeamsKeys={selectedTeamsKeys}
          selectedPriorityKeys={selectedPriorityKeys}
          selectedTeams={selectedTeams}
          isTeamLoaded={isTeamLoaded}
        />
      </TabPanel>
      <TabPanel
        value={tabIndex}
        index={1}
        sx={
          {
            // padding: '0px !important',
            // margin: '0px !important',
          }
        }
      >
        <ReportTable
          dateRangeReport={dateRangeReport}
          selectedTeamsKeys={selectedTeamsKeys}
          selectedPriorityKeys={selectedPriorityKeys}
          selectedTeams={selectedTeams}
        />
      </TabPanel>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <StatusDialog
        open={csvReport.value}
        onClose={csvReport.onFalse}
        // fullWidth={true}
        title="Download Report"
        fullWidth
        maxWidth="sm"
        content={
          <>
            <div style={{ position: 'relative', zIndex: 1301 }}>
              {' '}
              <DateRangePicker
                menuStyle={{ zIndex: 2000 }}
                character=" – "
                block
                shouldDisableDate={combine(allowedMaxDays(180), afterToday())}
                onChange={handleDownloadDateChangeReport}
                value={downloadDateRangeReport}
                ranges={rangesForDownload}
              />
            </div>
          </>
        }
        action={
          <Button
            variant="contained"
            sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
            color="primary"
            startIcon={
              isLoadingCsv ? (
                <CircularProgress size={16} color="inherit" /> // Show spinner if loading
              ) : (
                <FileDownloadIcon fontSize="small" />
              )
            }
            onClick={() => {
              downloadCSV();
              csvReport.onFalse();
            }}
          >
            Download Report
          </Button>
        }
      />
    </>
  );
};

export default Games;
